<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <base-logo class="main-logo logo-style"></base-logo>
            <div class="card card-auth create-password with-shadow">
                <h2 class="auth-heading">
                    Create password
                    <span> Please create your new account password. </span>
                </h2>
                <div class="row">
                    <div class="col-md-8">
                        <div class="auth-body has-icon">
                            <b-form @submit.stop.prevent="onSubmit()">
                                <b-form-group
                                    id="new-set-password-input"
                                    label="NEW PASSWORD"
                                    label-for="new-password"
                                >
                                    <b-form-input
                                        id="new-set-password-field"
                                        ref="password"
                                        v-model="formData.password"
                                        v-validate="{
                                            required: true,
                                            max: 20,
                                            min: 6,
                                            regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                        }"
                                        type="password"
                                        placeholder="Enter your account password"
                                        data-vv-name="new password"
                                        @input="checkPassword"
                                        :class="{
                                            'is-invalid':
                                                errors.has('new password'),
                                        }"
                                    ></b-form-input>

                                    <div class="password-validation">
                                        <i
                                            v-b-tooltip.hover
                                            class="icon-error_outline"
                                            placement="lefttop"
                                            title="
                                    - Password must be between 8-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+"
                                        ></i>
                                    </div>
                                </b-form-group>
                                <!--                        <password v-model="formData.password" :strength-meter-only="true" :badge = "true"/>-->
                                <b-form-group
                                    id="confirm-password-input"
                                    label="CONFIRM PASSWORD"
                                    label-for="confirm-password"
                                >
                                    <b-form-input
                                        id="confirm-password-field"
                                        v-model="formData.passwordConfirmation"
                                        v-validate="{
                                            required: true,
                                            confirmed: 'password',
                                            max: 20,
                                            min: 6,
                                            regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                        }"
                                        type="password"
                                        placeholder="Re-enter your account password"
                                        data-vv-name="password"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'confirmation password'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                                <base-button
                                    btn-label="CREATE"
                                    btn-type="submit"
                                    btn-variant="primary"
                                    :disabled="loading"
                                    :class="loading ? 'disabled' : ''"
                                ></base-button>
                                <base-toast></base-toast>
                            </b-form>
                        </div>
                    </div>
                    <div class="col-md-4 right">
                        <div class="right-panel-content">
                            <div class="input-container">
                                <ul>
                                    <li
                                        :class="{
                                            is_valid: contains_eight_characters,
                                        }"
                                    >
                                        Atleast 8 Characters
                                    </li>
                                    <li
                                        :class="{
                                            is_valid: contains_number,
                                        }"
                                    >
                                        Contains Number
                                    </li>
                                    <li
                                        :class="{
                                            is_valid: contains_uppercase,
                                        }"
                                    >
                                        Contains Uppercase
                                    </li>
                                    <li
                                        :class="{
                                            is_valid: contains_lowercase,
                                        }"
                                    >
                                        Contains Lowercase
                                    </li>
                                    <li
                                        :class="{
                                            is_valid:
                                                contains_special_character,
                                        }"
                                    >
                                        Contains Special Character:
                                        !@#$%^&amp;*_=+
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="checkmark_container"
                    :class="{ show_checkmark: valid_password }"
                >
                    <svg width="50%" height="50%" viewBox="0 0 140 100">
                        <path
                            class="checkmark"
                            :class="{ checked: valid_password }"
                            d="M10,50 l25,40 l95,-70"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
// import Password from 'vue-password-strength-meter'
const viewBrandingApi = new resource('configurations/branding')

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            formData: this.initializeFormData(),
            password: null,
            password_length: 0,
            contains_eight_characters: false,
            contains_number: false,
            contains_uppercase: false,
            contains_lowercase: false,
            contains_special_character: false,
            valid_password: false,
        }
    }, // End of Component > data

    components: {
        // Password
    },

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > created
  |--------------------------------------------------------------------------
  */
    async created() {
        // Change theme color
        await this.getBrandingData()
    }, // End of Component > created

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        if (this.$route.params && this.$route.params.token) {
            this.formData.token = this.$route.params.token
        }
    }, // End of Component > mounted

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        checkPassword() {
            this.password_length = this.formData.password.length
            const format = /[ !@#$%^&*()_+\-=]/

            if (this.password_length > 7) {
                this.contains_eight_characters = true
            } else {
                this.contains_eight_characters = false
            }

            this.contains_number = /\d/.test(this.formData.password)
            this.contains_uppercase = /[A-Z]/.test(this.formData.password)
            this.contains_lowercase = /[a-z]/.test(this.formData.password)
            this.contains_special_character = format.test(
                this.formData.password
            )

            if (
                this.contains_eight_characters === true &&
                this.contains_special_character === true &&
                this.contains_uppercase === true &&
                this.contains_lowercase === true &&
                this.contains_number === true
            ) {
                this.valid_password = true
            } else {
                this.valid_password = false
            }
        },
        initializeFormData() {
            return {
                password: '',
                passwordConfirmation: '',
                token: null,
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    const token = this.formData.token
                    let encryptedForm = this.$encrypt(this.formData)
                    const tempRequest = { data: encryptedForm }
                    // auth SetPassword action in auth store
                    let response = await this.$store.dispatch(
                        'authCreatePassword',
                        { payLoad: tempRequest, token: token }
                    )
                    if (response) {
                        this.$router.push({ name: 'view-activity-dashboard' })
                        this.clearFormData()
                    }

                    // Clearing formData fields on submit
                } catch (error) {
                    console.log(error, 'There is an error on create password')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method
    }, // End of Component > methods
} // End of export default
</script>
